<template>
  <div>
    <b-card 
      title="Masking"
      footer-tag="footer">
      <b-card-body>
      <table class="arith-table">
          <tr>
            <td> &nbsp; </td>
            <td><b-form-select v-model="operation" :options="operations"/> </td>
            <td colspan="2" align="right"><b-form-select v-model="size" :options="sizes"/></td>
            <td class="show-ascii"><b-form-checkbox v-model="showAscii" switch>Show ASCII</b-form-checkbox></td>
          </tr>
          <tr>
            <td align="right" class="arith-variables">
              Value =
            </td>
            <td class="arith-input">
              <u-input-number v-model="a" decimal binary hexadecimal/>
            </td>
            <td class="arith-equals"> &nbsp; </td>
            <td class="arith-numbers">
              {{convertedA}}
            </td>
            <td><div :hidden="!showAscii">'{{this.toAsciiChar(this.a.value)}}'</div></td>
          </tr>
          <tr>
            <td align="right" class="arith-variables">
              Mask =
            </td>
            <td class="arith-input">
              <u-input-number v-model="b" decimal binary hexadecimal/>
            </td>
            <td class="arith-equals arith-bottom"> {{this.operators[this.operation]}} </td>
            <td class="arith-numbers arith-bottom">
              {{convertedB}}
            </td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td colspan="4" class="arith-numbers">{{result}}</td>
            <td><div :hidden="!showAscii">'{{this.toAsciiChar(parseInt(result, 2))}}'</div></td>
          </tr>
        </table>
      </b-card-body>
        <template class="footer" #footer>
          Here's a good link descibing masking: <a target="_blank" href="https://en.wikipedia.org/wiki/Mask_(computing)">https://en.wikipedia.org/wiki/Mask_(computing)</a>
        </template>
      </b-card>
  </div>
</template>

<script>
import {Numbers, fillSignedBinary} from '@/util/numbers'
import UcrDrkInputNumber from '@/components/ucrdrk-input-number'

export default {
  name: 'addition',
  data () {
    return {
      a: {value: 0, base: 2},
      b: {value: 0, base: 2},
      additionBase: 2,
      size: 16,
      operation: 0,
      showAscii: false,
      sizes: [
        {value: 8, text: '8-bits'},
        {value: 16, text: '16-bits'},
        {value: 32, text: '32-bits'}
      ],
      operations: [
        {value: 0, text: 'Read bits'},
        {value: 1, text: 'Write 0'},
        {value: 2, text: 'Write 1'},
        {value: 3, text: 'Toggle bits'}
      ],
      operators: [
        'AND',
        'AND',
        'OR',
        'XOR'
      ]
    }
  },
  mixins: [Numbers],
  components: {
    'u-input-number': UcrDrkInputNumber
  },
  computed: {
    result: function () {
      var result = 0
      switch (this.operation) {
        case 0: result = this.a.value & this.b.value
          break

        case 1: result = this.a.value & ~(this.b.value)
          break

        case 2: result = this.a.value | this.b.value
          break

        case 3: result = this.a.value ^ this.b.value
          break
      }
      return fillSignedBinary(this.convert(result, this.additionBase), this.size)
    },
    convertedA: function () {
      return fillSignedBinary(this.convert(this.a.value, this.additionBase), this.size)
    },
    convertedB: function () {
      return fillSignedBinary(this.convert(this.operation === 1 ? ~(this.b.value) : this.b.value, this.additionBase), this.size)
    },
    overflow: function () {
      var sign = Math.sign(this.a.value)
      return this.a.valid && this.b.valid && sign === Math.sign(this.b.value) && (sign === 1 ? '0' : '1') !== this.sum[0]
    }
  },
  methods: {
    convert: function (value, base) {
      switch (base) {
        case 2:
          return this.toBinary(value >>> 0)
        case 10:
          return this.toDecimal(value >>> 0)
        case 16:
          return this.toHexadecimal(value)
        default:
          return ''
      }
    },
    toAsciiChar: function (integer) {
      var ch = String.fromCharCode(integer)
      return ch.charCodeAt(0) < 10 ? 'non-printable' : ch
    }
  }
}
</script>

<style scoped>
.card-footer {
  text-align: left;
}

.arith-numbers {
  font-family: monospace;
  font-size: x-large;
  text-align: right;
}

.arith-variables {
  width: 150px;
  min-width: 150px;
  max-width: 150px;

}

.arith-input {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
}

.arith-equals {
  width: 55px;
  min-width: 55px;
  max-width: 55px;
  text-align: center;
}

.arith-table {
  width: 425px;
  max-width: 425px;
  min-width: 425px;
}

.arith-bottom {
  border-bottom: 1pt solid black;
}

.show-ascii {
  white-space: nowrap;
}

th, td {
  padding-right: 12px;
  padding-bottom: 7px;
}
</style>


// WEBPACK FOOTER //
// src/components/masking.vue